import * as React from "react";
import { useStorageAppointmentDetails } from "./useStorageAppointmentDetails";
import { CommonFreightDeliveryInformation } from "inbounds/steps/ship/view/cards/confirmation/sharedComponents/CommonFreightDeliveryInformation";

interface StorageFreightDeliveryInformationProps {
  isDefaultOpen?: boolean;
}

export const StorageFreightDeliveryInformation: React.FC<StorageFreightDeliveryInformationProps> = ({
  isDefaultOpen = true,
}) => {
  const appointmentDetails = useStorageAppointmentDetails();
  const {
    proNumber,
    bolId,
    containerId,
    checkedOutAt,
    attachments,
    isLoading: isAppointmentLoading,
    onDownloadBol,
    isDownloadLoading,
  } = appointmentDetails;

  if (isAppointmentLoading) {
    return null;
  }

  return (
    <CommonFreightDeliveryInformation
      onDownloadBol={attachments && attachments.length > 0 ? onDownloadBol : undefined}
      isDownloadLoading={isDownloadLoading}
      isDefaultOpen={isDefaultOpen}
      proNumber={proNumber ?? undefined}
      bolId={bolId ?? undefined}
      containerId={containerId ?? undefined}
      checkedOutAt={checkedOutAt ?? undefined}
      attachments={attachments}
    />
  );
};
